import { useSetAtom, useAtomValue } from "jotai";
import { useIsScreenBelowBreakpoint } from "../../../hooks/useIsScreenBelowBreakpoint";
import { preSessionVibesOpenAtom } from "../../state";
import { VerticalVibesWrapper as VerticalVibes } from "./VerticalVibes";
import { HorizontalVibes } from "./HorizontalVibes";
import { VibesComponentProps } from "./types";
import { useBackgroundMusicPlayback as defaultUseBackgroundMusicPlayback } from "../background-action/useBackgroundMusicPlayback";
import { useEffect } from "react";
import { useTrackEvent } from "../../../segment/segment";
import { useParams } from "react-router-dom";
import { EventTypeEnum } from "../../../segment/types";
import { sessionInfoAtom } from "../../../state";

type PreSessionVibesWrapperProps = {
  VerticalVibesComponent?: React.FC<VibesComponentProps>;
  HorizontalVibesComponent?: React.FC<VibesComponentProps>;
  useBackgroundMusic?: typeof defaultUseBackgroundMusicPlayback;
};
export function PreSessionVibesWrapper({
  useBackgroundMusic = defaultUseBackgroundMusicPlayback,
  VerticalVibesComponent = VerticalVibes,
  HorizontalVibesComponent = HorizontalVibes,
}: PreSessionVibesWrapperProps) {
  const { handlePause } = useBackgroundMusic();
  const { userViewed } = useTrackEvent();
  const isSmallScreen = useIsScreenBelowBreakpoint("sm");

  const { providerShortId = "", patientShortId = "" } = useParams();
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);

  const appointmentShortId =
    useAtomValue(sessionInfoAtom)?.appointment?.shortId ?? "";

  async function closePreSessionVibes() {
    handlePause();
    setPreSessionVibesOpen(false);
  }

  useEffect(() => {
    userViewed(EventTypeEnum.PRE_SESSION_VIBES, {
      patientShortId,
      providerShortId,
      appointmentShortId,
    });
  }, [providerShortId, patientShortId, appointmentShortId, userViewed]);

  if (isSmallScreen) {
    return (
      <VerticalVibesComponent closePreSessionVibes={closePreSessionVibes} />
    );
  }

  return (
    <HorizontalVibesComponent closePreSessionVibes={closePreSessionVibes} />
  );
}
